<template>
  <sidebar :name="name" :title="$t('filters')" :loading="loading">

    <div class="p-4">
      <v-select
          multiple
          class="w-full"
          label="name"
          :hidden="true"
        />
    <vs-row vs-w="12" class="mb-2 mt-4">
      <vs-col
        vs-type="flex"
        vs-justify="flex-start"
        vs-align="center"
        vs-w="12"
      >
        <label>{{ $t('client') }}</label>
      </vs-col>
      <vs-col
        vs-type="flex"
        vs-justify="flex-start"
        vs-align="center"
        vs-w="12"
      >
        <v-select
          v-model="filters.client"
          multiple
          :options="clients"
          class="w-full"
          :reduce="client => client.ClientId"
          label="ClientName"
        />
      </vs-col>
    </vs-row>
    <vs-row vs-w="12" class="mb-2 mt-4">
      <vs-col
        vs-type="flex"
        vs-justify="flex-start"
        vs-align="center"
        vs-w="12"
      >
        <label>{{ $t('status') }}</label>
      </vs-col>
      <vs-col
        vs-type="flex"
        vs-justify="flex-start"
        vs-align="center"
        vs-w="12"
      >
        <v-select
          v-model="filters.status"
          multiple
          :options="status"
          class="w-full"
          :reduce="item => item.id"
          label="name"
        />
      </vs-col>
    </vs-row>
    <v-select
          multiple
          class="w-full"
          label="name"
          :hidden="true"
        />
    </div>

    <div class="mx-4" slot="footer">
      <vs-button color="success" type="border" class="mr-6" @click="setFilter">
        {{ $t('apply_filters') }}
      </vs-button>
      <vs-button color="primary" type="border" @click="clear">
        {{ $t('clear_filters') }}
      </vs-button>
    </div>
  </sidebar>
</template>

<script>
import Sidebar from '@/views/components/Sidebar.vue'
import InputDate from '@/components/custom/InputDate'
import vSelect from 'vue-select'
import loading from '@/mixins/Loading'

export default {
  components: {
    Sidebar,
    vSelect,
    InputDate,
  },
  computed: {
    isSidebarActive() {
      return this.$store.state.sidebar === this.name
    },
    isLoading() {
      return false
    }
  },
  data: () => ({
    filters: {
      client:null,
      status:null
    },
    name: 'review-order-filter',
    loading: false,
  }),
  methods: {
    clear() {
      const defaultFilter = {
        status:['1','2','4','5','6','7','8','9','11']
      }
      this.filters = Object.assign({}, defaultFilter)
      this.$emit('input', this.filters)
      this.$emit('search')
      this.close()
    },
    close() {
      this.$store.dispatch('toggleSidebar', '')
    },
    init() {
      this.filters = Object.assign({}, this.value)
    },
    setFilter() {
      this.$emit('input', this.filters)
      this.$emit('search')
      this.close()
    }
  },
  mixins: [loading],
  props: {
    clients:{
      type: Array,
      default:[]
    },
    status:{
      type: Array,
      default:[]
    },
    value: {
      type: Object,
      default: () => ({
      }),
    },
  },
  watch: {
    isSidebarActive(val) {
      if (val) {
        this.init()
      }
    }
  },
}
</script>

<style>
</style>